import { map } from 'rxjs/operators';
import { ofType, combineEpics } from 'redux-observable';
// ---- external imports ----

import { loadingActions } from '~/store';
import { CHECKPOINT_RELOAD, CHECKPOINT_RELOADED } from '~/store/checkpoint/actionTypes';
// ---- internal imports ----


const startReloadCheckpointLoading = (action$) => action$.pipe(
	ofType(CHECKPOINT_RELOAD),
	map(() => loadingActions.start(CHECKPOINT_RELOAD))
);

const endReloadCheckpointLoading = (action$) => action$.pipe(
	ofType(CHECKPOINT_RELOADED),
	map(() => loadingActions.end(CHECKPOINT_RELOAD))
);


export default combineEpics( 
	startReloadCheckpointLoading,
	endReloadCheckpointLoading
);
